import OrderHistoryInfoBaseModal from "./OrderHistoryInfoBaseModal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface OrderHistoryOrderInfoOrderCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const OrderHistoryOrderInfoOrderCancelModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: OrderHistoryOrderInfoOrderCancelModalProps) => {
  const { tSentence, t } = useI18nHelper();

  return (
    <OrderHistoryInfoBaseModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title={tSentence("order_history:cancel.modal.title")}
      body={tSentence("order_history:cancel.modal.description")}
      cancelName={t("close")}
      confirmName={t("cancel_action")}
      confirmBtnBgColor="#D32F2F"
    />
  );
};

export default OrderHistoryOrderInfoOrderCancelModal;
